// @wc-ignore-file
import type { DocSearch } from "@/features/docs/utils/doc-search";
import type { Notification } from "./notifications.types";

/**
 * Window event the bell dispatches so an already-mounted SimpleEditor can target
 * the mention without a navigation (the URL may not change).
 */
export const SCROLL_TO_MENTION_EVENT = "kairo:scroll-to-mention";

/** Detail of the SCROLL_TO_MENTION_EVENT window event. */
export interface ScrollToMentionDetail {
  docId: string;
  /** doc_mention: scroll the body to this user's mention span. */
  userId?: string;
  /** comment_mention (CR-150): open the panel on the thread holding this comment. */
  commentId?: string;
}

/**
 * Where a doc_mention / comment_mention notification lands on the document page.
 * A comment mention targets the mentioning comment (source_id = its messages.id);
 * a legacy one without source_id only opens the document — the recipient's mention
 * lives in the comment, not in the body, so scrolling the body would be wrong.
 *
 * KEEP IN SYNC with backend/api-server/src/routes/notification-email-worker.ts
 * resolveNotificationUrl: the email link of a comment mention targets the same
 * comment through `?commentId=`.
 */
export function docMentionTarget(
  docId: string,
  notification: Pick<Notification, "type" | "recipient_id" | "source_id">,
): { search: DocSearch; eventDetail: ScrollToMentionDetail } {
  if (notification.type === "comment_mention") {
    const commentId = notification.source_id ?? undefined;
    return commentId
      ? { search: { commentId }, eventDetail: { docId, commentId } }
      : { search: {}, eventDetail: { docId } };
  }
  const userId = notification.recipient_id;
  return { search: { mentionUserId: userId }, eventDetail: { docId, userId } };
}
